import styled from "styled-components"

export const ContainerWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  align-self: center;
  max-width: 70rem;
  margin: 0 auto;
`
